module.exports = __webpack_public_path__ + "static/img/02_06.57961dae.jpg";